import React from "react";
import loader from "../../../assets/images/Common/MainLoader.gif";
import classes from "./Loader.module.scss";

const Loader = ({ page, message, height, width }) => {
  return page ? (
    <div className={classes.loader_container}>
      {/* <div className={classes.loader}></div> */}
      <img src={loader} className={classes.loaderPage__gif} alt="loading" />
      {message && <div className={classes.loader__message}>{message}</div>}
    </div>
  ) : (
    <img
      src={loader}
      height={height && height}
      width={width && width}
      className={classes.loader__gif}
      style={{ height: height ? undefined : "50%" }}
      alt="loading"
    />
  );
};

export default Loader;
